import { DeceasedProfile } from './../../models/DeceasedProfile';
import { ApiResponse } from './../../models/ApiResponse';
import { HttpParams } from '@angular/common/http';
import { API_URL } from './../../app.constant';
import { Deceased } from './../../models/deceased';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

const CMS_GET_DECEASE_PROFILE_BY_MAIN_ACCOUNT_ID: string = "CMS_GetDeceaseProfileByMainAccountId" as const;

const COM_GET_DECEASED_PROFILE_IMAGE_BY_DECEASED_ID: string = "COM_GetDeceasedProfileImageByDeceasedId" as const;

@Injectable({
  providedIn: 'root'
})
export class DeceasedDataService {


  constructor(private http: HttpClient) { }

  getDeceaseProfileByMainAccountId(mainAccountId){

    let params = new HttpParams().set('mainAccountId', mainAccountId);

    return this.http.get<ApiResponse<DeceasedProfile[]>>(`${API_URL}/${CMS_GET_DECEASE_PROFILE_BY_MAIN_ACCOUNT_ID}`, {params});
  }


  getDeceasedProfileImageByDeceasedId(deceasedId){

    let params = new HttpParams().set('deceasedId', deceasedId);

    return this.http.get<ApiResponse<string>>(`${API_URL}/${COM_GET_DECEASED_PROFILE_IMAGE_BY_DECEASED_ID}`, {params});
  }
}
